// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-plus-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path
      fill='currentColor'
      d='M12.719 8.469a4.25 4.25 0 1 1-.001 8.499 4.25 4.25 0 0 1 0-8.5zm0 1.125a1 1 0 0 0-1 1v1.125h-1.125a1 1 0 1 0 0 2h1.125v1.125a1 1 0 0 0 2 0v-1.125h1.125a1 1 0 0 0 0-2h-1.125v-1.125a1 1 0 0 0-1-1z'
    />
    <path d='M1.031 12.719A4.784 4.784 0 0 1 7.69 8.32m-4.8-4.367a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0z' />
  </g>
);

export const viewBox = '0 0 18 18';
